import { ERROR_CODES } from '@/consts';

export default class PendingLogsInClosureRange extends Error {
  static code = ERROR_CODES.CASH_LOG_PENDING_LOGS_IN_CLOSURE_RANGE;

  constructor(message) {
    super(message || 'Pending Cash logs are in closure range.');
    this.code = ERROR_CODES.CASH_LOG_PENDING_LOGS_IN_CLOSURE_RANGE;
  }
}
